<!--
  A mail as it would leave, in a full-screen popup. Nothing is sent.

  Always mounted by its parent (never under a v-if): Vuesax moves the popup
  into document.body, and a popup destroyed while open freezes the page.
-->
<template>
  <vs-popup :title="title" :active.sync="isOpen" fullscreen>
    <div v-if="loading" class="hv2-loading">
      <vs-progress indeterminate color="primary" class="mb-2" />Building the mail…
    </div>
    <div v-else>
      <p class="hv2-sec-sub mb-3"><b>{{ subject }}</b><br />Nothing has been sent.</p>
      <iframe v-if="html" :srcdoc="html"
              style="width:100%;height:70vh;border:1px solid rgba(128,128,128,.2);border-radius:6px;background:#fff"></iframe>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'MailPreview',
  props: {
    open: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    subject: { type: String, default: '' },
    html: { type: String, default: '' },
    title: { type: String, default: 'Mail preview' }
  },
  computed: {
    isOpen: {
      get () { return this.open },
      set (v) { this.$emit('update:open', v) }
    }
  }
}
</script>
